
import { BlogPost } from "./types";

export const blogPosts: BlogPost[] = [
  {
    id: 1,
    title: "The Future of AI in Web Development",
    excerpt: "Exploring how artificial intelligence is transforming the way we build websites and web applications.",
    category: "Technology",
    date: "May 10, 2023",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5",
    tags: ["AI", "Web Development", "Future Tech"]
  },
  {
    id: 2,
    title: "Designing for Dark Mode: Best Practices",
    excerpt: "Tips and techniques for creating effective and appealing dark mode interfaces for your digital products.",
    category: "Design",
    date: "April 22, 2023",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b",
    tags: ["UI/UX", "Dark Mode", "Design"]
  },
  {
    id: 3,
    title: "Understanding WebAssembly",
    excerpt: "A deep dive into WebAssembly and how it's changing the performance landscape of web applications.",
    category: "Programming",
    date: "March 15, 2023",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6",
    tags: ["WebAssembly", "Performance", "JavaScript"]
  },
  {
    id: 4,
    title: "The Rise of Micro Frontends",
    excerpt: "How breaking down frontend monoliths into smaller, more manageable pieces is changing development teams.",
    category: "Architecture",
    date: "February 28, 2023",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7",
    tags: ["Micro Frontends", "Architecture", "Team Structure"]
  },
  {
    id: 5,
    title: "Implementing Secure Authentication",
    excerpt: "Best practices for implementing robust and secure authentication in your web applications.",
    category: "Security",
    date: "January 17, 2023",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475",
    tags: ["Security", "Authentication", "Web Development"]
  },
  {
    id: 6,
    title: "CSS Grid vs Flexbox",
    excerpt: "A comprehensive comparison between CSS Grid and Flexbox for modern web layouts.",
    category: "CSS",
    date: "December 5, 2022",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158",
    tags: ["CSS", "Layout", "Frontend"]
  }
];
